import { render, staticRenderFns } from "./NoiseBottomSkeletonBox.vue?vue&type=template&id=3ff3bc14"
import script from "./NoiseBottomSkeletonBox.vue?vue&type=script&lang=js"
export * from "./NoiseBottomSkeletonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports